import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["addon", "radio"]

  connect() {
    if (this.hasRadioTarget) {
      this.toggle({ target: this.radioTargets[1] })
    }
  }

  toggle({ target }) {
    const disabled = target.checked && target.value === "0"

    this.addonTargets.forEach(addon => {
      addon.disabled = disabled
    })
  }
}
